<h2 mat-dialog-title>{{ 'TEMPLATES.SAVE_AS_DIALOG.TITLE' | translate }}</h2>
<mat-dialog-content>
  <p>{{ 'TEMPLATES.SAVE_AS_DIALOG.DESCRIPTION' | translate }}</p>
  <div class="form-container">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'TEMPLATES.SAVE_AS_DIALOG.TEMPLATE_NAME' | translate }}</mat-label>
      <input
        matInput
        [(ngModel)]="templateName"
        [placeholder]="'TEMPLATES.SAVE_AS_DIALOG.TEMPLATE_NAME_PLACEHOLDER' | translate"
        (keydown)="onKeydown($event)"
        cdkFocusInitial
        required
      />
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">{{ 'COMMON.CANCEL' | translate }}</button>
  <button mat-flat-button color="primary" (click)="onSave()" [disabled]="isSaveDisabled">{{ 'COMMON.SAVE' | translate }}</button>
</mat-dialog-actions>
